import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldType } from '@ngx-formly/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { BaseCategoryTypeEnum } from 'src/app/_models';
import { ICONS } from '../../../../_helpers/icons.constants';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';

/**
 * New-design counterpart of the legacy `formly-category-view`: the read-only preview of the
 * base template a category is built on. The legacy control is still used by the
 * import-expense-categories edit panel, so both exist until that screen is converted too.
 */
@Component({
    selector: 'formly-category-template',
    templateUrl: './formly-category-template.component.html',
    standalone: true,
    imports: [CommonModule, TranslateModule]
})
export class FormlyCategoryTemplateComponent extends FieldType implements OnInit, OnDestroy {

    param: any;
    public ICONS = ICONS;
    baseCategoryTypeEnum = BaseCategoryTypeEnum;

    baseCategoryId: number;
    baseCategoryNameModel: string;
    previewImage: string;
    orgCategoryListByBaseCatId = <any[]>[];

    private valueChangeSubscription: Subscription;

    private static readonly PREVIEW_IMAGES: { [key: number]: string } = {
        [BaseCategoryTypeEnum.Entertainment]: '/assets/images/entertainment.png',
        [BaseCategoryTypeEnum.Generic]: '/assets/images/generic_Category.png',
        [BaseCategoryTypeEnum.NoReceiptCategory]: '/assets/images/no_receipt_category.png',
        [BaseCategoryTypeEnum.Hotel]: '/assets/images/hotel_lodgings.png',
        [BaseCategoryTypeEnum.Mileage]: '/assets/images/manual_mileage.png',
        [BaseCategoryTypeEnum.MileageGPS]: '/assets/images/mileageGps.png',
        [BaseCategoryTypeEnum.MileageGoogle]: '/assets/images/mileage_google.png'
    };

    private static readonly TEMPLATE_NAME_KEYS: { [key: number]: string } = {
        [BaseCategoryTypeEnum.Entertainment]: 'Entertainment',
        [BaseCategoryTypeEnum.Generic]: 'standard_category',
        [BaseCategoryTypeEnum.Hotel]: 'HotelandLodgings',
        [BaseCategoryTypeEnum.Mileage]: 'Mileage',
        [BaseCategoryTypeEnum.MileageGPS]: 'mileage_gps',
        [BaseCategoryTypeEnum.MileageGoogle]: 'mileage_google',
        [BaseCategoryTypeEnum.NoReceiptCategory]: 'receipt_type_text9'
    };

    constructor(private dynamicFormService: DynamicFormService,
        private translate: TranslateService,
        private cdr: ChangeDetectorRef) {
        super();
    }

    ngOnInit() {
        if (this.to.options && this.to.options[0] && this.to.options[0].categoryDetail) {
            this.baseCategoryId = Number(this.to.options[0].categoryDetail.baseCategoryId);
            this.fnBindTemplate();
        }
        // The host screen republishes the base-template dropdown's value here so this
        // preview can follow it.
        this.valueChangeSubscription = this.dynamicFormService.getValueChangeEvent().subscribe(data => {
            this.baseCategoryId = data;
            this.fnBindTemplate();
            this.cdr.detectChanges();
        });
    }

    ngOnDestroy() {
        this.valueChangeSubscription?.unsubscribe();
    }

    fnBindTemplate() {
        const nameKey = FormlyCategoryTemplateComponent.TEMPLATE_NAME_KEYS[this.baseCategoryId];
        this.baseCategoryNameModel = nameKey ? this.translate.instant(nameKey) : '';
        this.previewImage = FormlyCategoryTemplateComponent.PREVIEW_IMAGES[this.baseCategoryId]
            ?? '/assets/images/No-option-selected.png';
        this.fnBindActiveCategories();
    }

    fnBindActiveCategories() {
        let manageCategoryList = [];
        if (this.to.options && this.to.options[0] && this.to.options[0].categoryDetail && this.to.options[0].manageCategoryView) {
            manageCategoryList = this.to.options[0].manageCategoryList;
        }
        this.orgCategoryListByBaseCatId = manageCategoryList
            .filter(a => a.baseCategoryId == this.baseCategoryId && a.isActive == true);
    }

    /** The host screen owns the panel — it renders alongside this screen's other panels
     *  rather than from inside a form control. */
    fnOpenActiveCategories() {
        if (this.to.onActiveCategoriesClick) {
            this.to.onActiveCategoriesClick(this.orgCategoryListByBaseCatId);
        }
    }
}
